<template>
    <q-dialog ref="dialogRef" @hide="onDialogHide">
        <q-card class="q-dialog-plugin">
            <q-card-section>
                <div class="text-h6">
                    Limit reached
                </div>
                <q-separator/>
            </q-card-section>

            <q-card-section class="q-my-md">
                You already have {{ props.subdomainCount }} Domains out of {{ subdomainCountLimit }}
            </q-card-section>

            <q-card-section class="q-my-md">
                <p class="text-h7">In order to unlock more Domains for every Memo.Link user please consider
                    donating any token on Ethereum (L1 or L2) or Solana at the following addresses:</p>
                <q-list class="q-mt-md">
                    <q-item>
                        <q-item-section>
                            <q-item-label class="text-bold">
                                <a href="https://app.ens.domains/memolink.eth" target="_blank">memolink.eth</a>
                                = [0x6Eff...2F85]
                            </q-item-label>
                        </q-item-section>
                    </q-item>
                    <q-item>
                        <q-item-section>
                            <q-item-label class="text-bold">
                                <a href="https://www.sns.id/domain/memolink" target="_blank">memolink.sol</a>
                                = [5qMi...oTLr]
                            </q-item-label>
                        </q-item-section>
                    </q-item>
                </q-list>
            </q-card-section>

            <q-card-actions align="right" class="q-px-md">
                <q-btn color="grey" label="Cancel" @click="onDialogCancel" push/>
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>

<script setup>
const props = defineProps(['subdomainCount', 'subdomainCountLimit'])
import { useDialogPluginComponent } from 'quasar'

defineEmits([...useDialogPluginComponent.emits])

const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()
</script>

<style lang="sass" scoped>
body.screen--xl, body.screen--lg
    .q-dialog-plugin
        width: 900px

</style>

